import { AxiosInstance } from 'axios'
import { createAddressesService } from '@/api/modules/addresses'
import { createBasketModule } from '@/api/modules/basket'
import { createCategoryService } from '@/api/modules/category'
import { createCityModule } from '@/api/modules/city'
import { createDeliveryModule } from '@/api/modules/delivery'
import { createDeliveryTemplatePageModule } from '@/api/modules/delivery/slug'
import { createGeocodeService } from '@/api/modules/geo/geocode'
import { createHalvesService } from '@/api/modules/halves'
import { createMainModule } from '@/api/modules/main'
import { createNewsService } from '@/api/modules/news'
import { createOrderModule } from '@/api/modules/order'
import { createPromocodesModule } from '@/api/modules/promocodes'
import { createSalesModule } from '@/api/modules/sales'
import { createSiteModule } from '@/api/modules/site'
import { createUserModule } from '@/api/modules/user'
import { createWokService } from '@/api/modules/wok'

export function createApiService({
  sentry,
  axios,
  city,
  hostname,
}: {
  sentry: any
  axios: AxiosInstance
  city: string
  hostname: string
}) {
  const siteModule = createSiteModule({ axios, sentry, city })
  const cityModule = createCityModule({ axios, sentry, city })
  const mainModule = createMainModule({ axios, sentry, city })
  const categoryModule = createCategoryService({
    axios,
    sentry,
    city,
  })
  const userModule = createUserModule({ axios, sentry, city, hostname })
  const basketModule = createBasketModule({
    axios,
    sentry,
    city,
    hostname,
  })
  const addressesModule = createAddressesService({
    axios,
    sentry,
    city,
    hostname,
  })
  const promocodesModule = createPromocodesModule({ axios, sentry, city })
  const orderModule = createOrderModule({ axios, sentry, city })
  const salesModule = createSalesModule({ axios, sentry, city })
  const wokModule = createWokService({ axios, sentry, city, hostname })
  const newsModule = createNewsService({ axios, sentry, city })
  const halvesModule = createHalvesService({ axios, sentry, city, hostname })
  const deliveryModule = createDeliveryModule({ axios, sentry, city })
  const deliveryTemplatePageModule = createDeliveryTemplatePageModule({
    sentry,
    city,
  })
  const geocodeService = createGeocodeService({
    axios,
    sentry,
    city,
    hostname,
  })

  return {
    site: siteModule,
    city: cityModule,
    main: mainModule,
    category: categoryModule,
    user: userModule,
    basket: basketModule,
    addresses: addressesModule,
    promocodes: promocodesModule,
    order: orderModule,
    sales: salesModule,
    wok: wokModule,
    news: newsModule,
    halves: halvesModule,
    delivery: deliveryModule,
    deliveryTemplate: deliveryTemplatePageModule,
    geocode: geocodeService,
  }
}
